const APP_NAME = 'basqet';
const APP_BRAND_COLOR = '#150F2F';

export { APP_BRAND_COLOR, APP_NAME };
